module.exports = __webpack_public_path__ + "static/multiples-021a9b05a62f6ccd7ab87866c67515a5.svg";